import React from 'react';

export const DroneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" /> {/* Central body of the drone */}
    <line x1="12" y1="12" x2="8" y2="8" /> {/* Top-left propeller arm */}
    <circle cx="7" cy="7" r="4" /> {/* Top-left propeller */}
    <line x1="12" y1="12" x2="16" y2="8" /> {/* Top-right propeller arm */}
    <circle cx="17" cy="7" r="4" /> {/* Top-right propeller */}
    <line x1="12" y1="12" x2="16" y2="16" /> {/* Bottom-right propeller arm */}
    <circle cx="17" cy="17" r="4" /> {/* Bottom-right propeller */}
    <line x1="12" y1="12" x2="8" y2="16" /> {/* Bottom-left propeller arm */}
    <circle cx="7" cy="17" r="4" /> {/* Bottom-left propeller */}
  </svg>
);

export const CalculatorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <line x1="6" y1="10" x2="18" y2="10" />
    <line x1="6" y1="14" x2="10" y2="14" />
    <line x1="14" y1="14" x2="18" y2="14" />
    <line x1="6" y1="18" x2="10" y2="18" />
    <line x1="14" y1="18" x2="18" y2="18" />
    <line x1="10" y1="6" x2="14" y2="6" />
  </svg>
);

export const ToolkitIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
    <path d="M16 3h-8v4h8V3z" />
  </svg>
);

export const BoatSensorIcon = ({ style }) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M21 21H3v-2h18v2z" /> {/* Base of the boat */}
    <path d="M12 2L3 10h18L12 2z" /> {/* Sail */}
    <line x1="12" y1="2" x2="12" y2="15" /> {/* Mast */}
    <polygon points="6 15, 18 15, 12 21" fill="currentColor" /> {/* Hull */}
  </svg>
);


export const NetworkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="7" rx="8" ry="3" /> {/* Top ellipse */}
    <path d="M4 7v6c0 1.657 3.582 3 8 3s8-1.343 8-3V7" /> {/* Vertical lines for the top layer */}
    <ellipse cx="12" cy="13" rx="8" ry="3" /> {/* Middle ellipse */}
    <path d="M4 13v6c0 1.657 3.582 3 8 3s8-1.343 8-3v-6" /> {/* Vertical lines for the middle layer */}
    <ellipse cx="12" cy="19" rx="8" ry="3" /> {/* Bottom ellipse */}
  </svg>
);

export const StonksIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    stroke="currentColor"
    strokeWidth="40"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g fill="none">
      {/* Axes */}
      <path d="M64 448 V64 M64 448 H448" />
      {/* Price line */}
      <polyline points="64,384 128,320 192,352 256,256 320,288 384,192 448,224" />
      {/* Data points */}
      <circle cx="64" cy="384" r="8" />
      <circle cx="128" cy="320" r="8" />
      <circle cx="192" cy="352" r="8" />
      <circle cx="256" cy="256" r="8" />
      <circle cx="320" cy="288" r="8" />
      <circle cx="384" cy="192" r="8" />
      <circle cx="448" cy="224" r="8" />
    </g>
  </svg>
);

export const ArcAgiIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    stroke="currentColor"
    strokeWidth="40"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g fill="none">
      {/* Grid representing ARC puzzles */}
      <path d="M64 64 H448 M64 192 H448 M64 320 H448 M64 448 H448 M64 64 V448 M192 64 V448 M320 64 V448 M448 64 V448" />
      {/* Abstract shapes showing varied tasks */}
      {/* Square in top-left cell */}
      <rect x="96" y="96" width="64" height="64" />
      {/* Circle in center cell */}
      <circle cx="256" cy="256" r="32" />
      {/* Triangle in bottom-right cell */}
      <polyline points="384,352 356,400 412,400 384,352" />
    </g>
  </svg>
);

export const MemoryLookupIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    stroke="currentColor"
    strokeWidth="32"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g fill="none">
      {/* Key/value memory rows */}
      <rect x="240" y="80" width="208" height="96" rx="16" />
      <rect x="240" y="208" width="208" height="96" rx="16" />
      <rect x="240" y="336" width="208" height="96" rx="16" />
      {/* Divider between the key half and the value half of each row */}
      <path d="M320 80 V176 M320 208 V304 M320 336 V432" />
      {/* The question, attending to the matching row */}
      <circle cx="96" cy="256" r="48" />
      <path d="M144 256 H240" />
    </g>
  </svg>
);



